import { ActionReducer, Store, Action } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';
import { mergeDeep } from '../helpers/data-helpers';

export class E2eReplaceState implements Action {
  readonly type = 'E2E_REPLACE_STATE';
  constructor(public payload: any) {}
}

export function replaceStateAction(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action: any) {
    if (action.type === 'E2E_REPLACE_STATE') {
      return mergeDeep(state, action.payload);
    }

    return reducer(state, action);
  };
}

export function onAppInit(store: Store<any>, http: HttpClient) {
  return () => {
    window.addEventListener('replaceAppState', (e: any) => {
      if (e.detail.newState) {
        http.get(`/assets/json/${e.detail.newState}.json`).subscribe(state => {
          store.dispatch(new E2eReplaceState(state));
        });
      } else if (e.detail.newStateJson) {
        store.dispatch(new E2eReplaceState(e.detail.newStateJson));
      }
    });
  };
}

export const StateReplaceProvider = {
  provide: APP_INITIALIZER,
  useFactory: onAppInit,
  multi: true,
  deps: [Store, HttpClient]
};
